import PropTypes from 'prop-types';
import React from 'react';

const PlusMinus = ({className, field, handleChange, header, label, singularLabel, value, zeroLabel}) => {

  const buildLabel = () => {
    if (value === 0) {
      return zeroLabel;
    } else if (value === 1) {
      return '' + value + ' ' + singularLabel;
    } else {
      return '' + value + ' ' + label;
    }
  }

  return (
    <div className={"search-input medium " + field + "-selector-input " + className}>
      <h2>{header}</h2>
      <div className="lower-sec">
        <div className="button-combo">
          <button type="button" className="minus square-button noselect" aria-label={`decrease minimum ${header}`}
            onClick={handleChange.bind(this, field, -1)}>–</button>
          &nbsp;
          <button type="button" className="plus square-button noselect" aria-label={`increase minimum ${header}`}
            onClick={handleChange.bind(this, field, 1)}>+</button>
          <div className="button-select-display">
            {buildLabel()}
          </div>
        </div>
      </div>
    </div>
  );
}

PlusMinus.propTypes = {
  className: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  singularLabel: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  zeroLabel: PropTypes.string.isRequired
};

export default PlusMinus;



// WEBPACK FOOTER //
// ./src/components/search/controls/plus-minus.jsx